
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productImageStyles.compareCheckbox = {
	css: css`
		align-self: center;
		padding-top: 20px;
		label {
			${({ theme }: { theme: BaseTheme }) =>
			breakpointMediaQueries(theme, [
				css`
					margin-left: 7px !important;
					font-size:12px;
				`,
				css``,
				css``,
				css``,
				css``,
			])}
		}
	`
}

productImageStyles.productImage = {
	image: {
		css: css`
			img {
				height: 187px;
				margin: 0px auto;
				max-width: 167px;
				object-fit: contain;
				width: 100%;
			}
		`,
	},
}